import './style.scss';

export default function Contact(){

  
    return(
      <section id="contactMe">  
        <div className="containerContact" >
   
          <div className="containerForm">
            <h1 className="titleForm">Formulaire de contact</h1>
   
            <iframe
              src="https://tally.so/embed/nrDMOL?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
    
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Nous contacter">
            </iframe>
  
          </div>
  
  
        </div></section>
    );
  }
  